import { OptimizationSessionContext } from '@/dashboards/CampaignOptimization/context/OptimizationSessionContext';
import { useContext } from 'use-context-selector';

export const useOptimizationSession = () => {
    const value = useContext(OptimizationSessionContext);
    if (!value) {
        throw new Error('useOptimizationSession must be used within an OptimizationSessionProvider');
    }
    return value;
};
